export const sendMessage = (type: string, value: any): void => {
    try {
        const message = JSON.parse(JSON.stringify({ type, value }));
        //if (window.origin) {
        //    window.postMessage(message, '*');
        //} else {
            window.parent.postMessage(message, '*');
        //}
    } catch (e) {
        console.warn('post message error :' + e);
    }
}